module.exports = __webpack_public_path__ + "img/9ac20dd1de7912fbf8e9af15888e155b.png";